import React from "react";
import { useSearchParams } from "react-router-dom";
import { optionalId } from "./compose/composerAdapters";
import EmailComposerForm from "./compose/EmailComposerForm";

const EmailCompose = () => {
    const [params] = useSearchParams();
    const context = {
        replyId: optionalId(params.get("reply")),
        accountId: optionalId(params.get("customer")),
        personId: optionalId(params.get("person")),
    };
    return <EmailComposerForm key={JSON.stringify(context)} context={context} />;
};

export default EmailCompose;
